import React, { useMemo } from "react"

import { connect } from "scrivito"
import { SharedProjectPageObj } from "scrivito/Objs/SharedProjectPage/SharedProjectPageObjClass"

import { ProjectChatContextProvider } from "pages/project-page/chat-context/ProjectChatContext"

import { SharedProjectPage } from "./SharedProjectPage"
import {
  SharedProjectContext,
  SharedProjectContextType
} from "./context/SharedProjectContext"
import { useSharedProjectPageModel } from "./hooks/useSharedProjectPageModel"

export interface SharedProjectPageConnectorProps {
  projectShareID: string
  page: SharedProjectPageObj
}

function SharedProjectPageConnectorInner(
  props: SharedProjectPageConnectorProps
) {
  const { projectShareID } = props
  const contextValue = useMemo<SharedProjectContextType>(
    () => ({ projectShareID }),
    [projectShareID]
  )
  return (
    <SharedProjectContext.Provider value={contextValue}>
      <SharedProjectPage {...useSharedProjectPageModel(props)} />
    </SharedProjectContext.Provider>
  )
}

const ConnectedSharedProjectPageConnectorInner = React.memo(
  connect(SharedProjectPageConnectorInner)
)

export const SharedProjectPageConnector = React.memo(
  (props: SharedProjectPageConnectorProps) => (
    <ProjectChatContextProvider>
      <ConnectedSharedProjectPageConnectorInner {...props} />
    </ProjectChatContextProvider>
  )
)
